

// file: `src/Components/loading-transition/LoadingScreen.jsx`
import { useEffect, useState } from "react";

export default function LoadingScreen({ started, setStarted, progress = 0 }) {
    // displayedProgress animé localement pour l'effet incrémental
    const [displayedProgress, setDisplayedProgress] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    let path;

    // incrémente displayedProgress jusqu'à la valeur réelle progress
    useEffect(() => {
        const interval = setInterval(() => {
            setDisplayedProgress((prev) => {
                if (prev < progress) {
                    return prev + 1;
                }
                return prev;
            });
        }, 20);

        return () => clearInterval(interval);
    }, [progress]);

    // listener resize fiable
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 768);
        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    if (isMobile) {
        path = "M 0 1 V 0 C 0.4149 0.04 0.6064 0.04 1 0 V 1 C 1 1 0 1 0 1 Z";
    } else {
        path = "M 0 1 V 0 C 0.4149 0.08 0.6064 0.08 1 0 V 1 C 1 1 0 1 0 1 Z";
    }

    // quand tout est chargé et l'animation locale est à 100%, on lance la transition
    useEffect(() => {
        if (progress === 100 && displayedProgress === 100) {
            const t = setTimeout(() => {
                setStarted(true);
            }, 1000);
            return () => clearTimeout(t);
        }
    }, [progress, displayedProgress, setStarted]);

    return (
        <>
            <div className={`overlayTransition ${started ? "active" : ""}`}>
                {/*<svg className="overlay-background" preserveAspectRatio="none" viewBox="0 0 1 1">*/}
                {/*    <path fill="#ffffff" d={path} />*/}
                {/*</svg>*/}

                <div className="loading-percentage">
                    {Math.round(displayedProgress)}%
                </div>

                {location.pathname === '/' ? (
                    <h1>Hector Gauthier | Portfolio</h1>
                ) : (
                    <span>Hector Gauthier | Portfolio</span>
                )}
            </div>

            <svg className="overlay-logo" id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.36 94.36"><g id="Calque_1-2"><g><rect className="cls-2" x="12.71" y="41.73" width="32.45" height="10.91" transform="translate(57.86 94.36) rotate(180)"/><rect className="cls-2" x="26.2" y="31.73" width="30.89" height="10.91" transform="translate(78.84 -4.46) rotate(90)"/><path className="cls-2" d="M47.05,55.2h-10.86c0,5.49,4.26,14.54,10.86,17.42v-17.42Z"/><path className="cls-1" d="M0,47.18c0,9.12,2.61,17.64,7.11,24.87V22.31C2.61,29.54,0,38.06,0,47.18Z"/><path className="cls-1" d="M47.18,10.89c14.16,0,26.44,8.16,32.42,20.01h11.86C84.82,12.88,67.48,0,47.18,0c-9.54,0-18.42,2.86-25.85,7.74v14c6.59-6.69,15.74-10.85,25.85-10.85Z"/><path className="cls-1" d="M94.05,41.84v-.08s0,0,0,0h-31.41v10.85h20.44c-2.63,17.45-17.72,30.86-35.88,30.86-10.11,0-19.27-4.16-25.85-10.85v14c7.43,4.89,16.31,7.74,25.85,7.74,26.02,0,47.18-21.16,47.18-47.18,0-1.81-.12-3.59-.31-5.35Z"/><path className="cls-2" d="M21.33,72.62V21.74c-6.45,6.55-10.44,15.54-10.44,25.44s3.99,18.88,10.44,25.44Z"/></g></g></svg>
        </>
    );
}

